// extracted by mini-css-extract-plugin
export var label = "_aw-1";
export var reminder = "_aw-0";